import { AttentionResult, ImageData } from "./get-attention-level";
import { ImageWithLandMark } from "./image-with-landmark";

interface AttentionBody {
  shape: number[];
  imagesLandmarks: { _x: number; _y: number }[];
  fps: number;
}

export async function parseJson(
  imageWithLandMarks: ImageWithLandMark[],
  imageData: ImageData
) {
  let imageShape: any = null;
  const landmarksArray: any = [];
  for (const iterator of imageWithLandMarks) {
    if (imageShape == null) {
      imageShape = [iterator.image.width, iterator.image.height];
    }

    landmarksArray.push(iterator.results);
  }

  const fps = getFps(imageData, landmarksArray.length);

  const json = {
    shape: imageShape,
    imagesLandmarks: landmarksArray,
    fps: fps,
  } as unknown as AttentionBody;

  return json;
}

export async function sendRequest(
  url: string,
  body: Record<string, any> | string
): Promise<AttentionResult> {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const options = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    };

    const res = await fetch(url, options);

    if (!res.ok) {
      throw new Error(`Cannot make request: ${(res.json() as any)["message"]}`);
    }

    return res.json();
  } catch (error: any) {
    if (error instanceof TypeError) {
      throw new Error(`Cannot access ${url}.`);
    }

    throw new Error(`Unknown Error: ${error}.`);
  }
}

function getFps(imageData: ImageData, arraySize: number) {
  if (imageData.fps) {
    return imageData.fps;
  }

  if (imageData.videoTime) {
    return imageData.videoTime / arraySize;
  }

  throw new Error("Need FPS or Video Time to compute time per seconds.");
}
